import React from 'react';
import Button from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';
import { companyInfo } from '../data/content';

export default function Emergency() {
  return (
    <div className="bg-slate-50 min-h-screen">
      {/* Hero */}
      <div className="bg-red-600 text-white py-20">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-6 animate-pulse">
            <SafeIcon name="AlertTriangle" className="text-4xl" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-6">24/7 Emergency Plumbing</h1>
          <p className="text-xl md:text-2xl mb-8 font-medium">Stop the damage now. We have plumbers on standby in Montreal.</p>
          <a 
            href={`tel:${companyInfo.phone.replace(/\D/g,'')}`}
            className="inline-flex items-center justify-center px-8 py-5 text-2xl font-bold bg-white text-red-600 rounded-full shadow-2xl hover:bg-slate-100 transition-transform hover:scale-105"
          >
            <SafeIcon name="Phone" className="mr-3" /> {companyInfo.phone}
          </a>
          <p className="mt-6 text-red-100">Call right now for dispatch within 60 minutes.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-center mb-12">Common Emergencies We Handle Immediately</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { title: "Burst Pipes", desc: "Shut off your main water valve immediately and call us. We repair frozen and burst pipes to prevent flooding." },
            { title: "Sewer Backups", desc: "Raw sewage is a health hazard. We clear main line blockages and sanitize affected areas." },
            { title: "Overflowing Toilets", desc: "If plunging doesn't work and water is rising, turn off the valve behind the toilet and contact us." },
            { title: "No Hot Water", desc: "Total failure of your water heater, especially leaking tanks, requires immediate replacement." },
            { title: "Major Leaks", desc: "Water dripping from ceilings or pooling under cabinets needs rapid detection and repair." },
            { title: "Sump Pump Failure", desc: "During heavy Montreal rainstorms, a failed sump pump means a flooded basement. We replace them fast." }
          ].map((item, i) => (
            <div key={i} className="bg-white p-6 rounded-xl border-l-4 border-red-500 shadow-sm">
              <h3 className="text-xl font-bold mb-2 text-slate-800">{item.title}</h3>
              <p className="text-slate-600">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
          <h3 className="text-2xl font-bold mb-4">What to do while waiting for us:</h3>
          <ol className="list-decimal list-inside space-y-4 text-lg text-slate-700 font-medium">
            <li><strong className="text-slate-900">Shut off the water:</strong> Locate your main water shut-off valve (usually in the basement near the front of the house) and turn it clockwise.</li>
            <li><strong className="text-slate-900">Turn off electricity:</strong> If water is near electrical outlets or appliances, turn off the power at the breaker panel.</li>
            <li><strong className="text-slate-900">Move valuables:</strong> Remove rugs, furniture, and boxes away from the wet area to minimize damage.</li>
            <li><strong className="text-slate-900">Wait safely:</strong> Our technician will be there shortly to take control of the situation.</li>
          </ol>
        </div>
      </div>
    </div>
  );
}